<template>
  <div class="banner wow fadeInDown" v-if="banners.old && banners.old.length">
    <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper" id="swiper">
      <swiper-slide v-for="(item, index) in banners.old" :key="index">
        <img :src="item.bannerImg" alt="" @click="link(item, index)">
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data() {
    return {
      allList: [],
      swiperOptions: {
        loop: true,
        autoplay: 3000,
        autoplayDisableOnInteraction : false,
        // 播放的速度
        speed: 1000,
        //分页器设置
        pagination: {
          el: ".swiper-pagination7",
          clickable: true,
        },
      },
    }
  },
  methods: {
    link(item, index) {
      this.$jsAPI('track','homeClick',
          {
            'floor_var': '长条广告banner',
            'position_var': index + 1 + '',
            'flowName_var': item.bannerTitle,
            'industryFirstCate_var': '无',
            'industrySecCate_var': '无',
            'tabName_var': '无',
          }
      );
      gio('track','homeClick',
          {
            'floor_var': '长条广告banner',
            'position_var': index + 1 + '',
            'flowName_var': item.bannerTitle,
            'industryCate_var': '无',
            'industryFirstCate_var': '无',
            'tabName_var': '无',
          }
      );
      this.bannerTurn(item)
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .banner {
    position: relative;
    width: 100%;
    height: 3.56rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/banner-bg.jpg");
    background-size: cover;
    padding: .54rem 1.1rem 0;

    img {
      border-radius: .16rem;
      cursor: pointer;
      width: 100%;
      height: 1.76rem;
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .banner {
    position: relative;
    width: 100%;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/banner-bg-wap.jpg");
    background-size: 100% 100%;
    padding: 0 .4rem .5rem;

    img {
      border-radius: .16rem;
      cursor: pointer;
      width: 100%;
      height: .71rem;
    }
  }
    
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/banner.vue